export function getCachesearches ({ state, commit }, { search, page }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/cachesearches', { params: { search, page } })
      .then((response) => {
        if (response.data.cachesearches) {
          commit('setCachesearches', response.data.cachesearches)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getCachesearch ({ state, commit }, warehouse) {
  return new Promise((resolve, reject) => {
    if (warehouse) {
      axiosInstance.get('/v1/cachesearches/' + warehouse)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No warehouse id'))
    }
  })
}

export function deleteCachesearch ({ state, commit }, { warehouse, key }) {
  return new Promise((resolve, reject) => {
    if (warehouse) {
      axiosInstance.delete('/v1/cachesearches/' + warehouse, { data: { key } })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No warehouse id'))
    }
  })
}
